<template>
  <chart
    ref="chart"
    autoresize
  />
</template>

<script>
import { HorizontalBar } from 'vue-chartjs'

export default {
  components: {
    chart: HorizontalBar
  },
  props: {
    labels: {type: Array, default: ['A', 'B']},
    data: {type: Array, default: [50, 50]},
  },
  data() {
    return {
      trans: trans,
      numeral: numeral,
    }
  },
  methods: {
    render() {
      if (this.data == null) return
      this.$refs.chart.renderChart({
        labels: this.labels,
        datasets: [
          {
            data: this.data,
            //backgroundColor: ['#92D050', '#ddd'],
          },
        ]
      }, {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: false,
        },
        legend: {
          display: false
        },
      })
    },
  },
  mounted() {
    this.render()
  }
}
</script>